export default "__VITE_ASSET__C47pT5xw__"